import { JSX } from "solid-js";
import { SectionData } from "../data/home_webstore_telescope_route_data";

type SectionHeaderProps = {
  section: SectionData;
  colorIndex: number;
  children: JSX.Element;
};

// 3 colors to rotate through for sections
const SECTION_COLORS = [
  "#351A75", // Purple
  "#68123D", // Burgundy
  "#0B4627", // Green
];

/**
 * Section Header with Themed Background
 * Full-width colored background with section title and brand grid
 */
export function SectionHeader(props: SectionHeaderProps): JSX.Element {
  const backgroundColor = () =>
    SECTION_COLORS[props.colorIndex % SECTION_COLORS.length];

  return (
    <div
      class="flex w-full flex-col items-center gap-5 pb-6 pt-7"
      style={{ "background-color": backgroundColor() }}
    >
      <div class="flex w-full max-w-[1024px] items-center px-3 sm:px-0">
        <h2 class="whitespace-nowrap text-caption-semi-bold uppercase text-white">
          {props.section.title}
        </h2>
      </div>
      {props.children}
    </div>
  );
}
